<template>
	<div class="main bgwhite" v-title data-title="零部件企业" style="padding-bottom: 50px;">
		<iHeader ref="loginIndex" :message="msg"></iHeader>
		<div class="barprebox max1350 mt25" v-if="newlist.length>0">
			<div class="listD" v-for="(item,index) in newlist" :key="index">
				<img class="newimg"
					src="https://images.mfcad.cn/goods/2021/3/12/281ea805-e12b-41b0-8644-a9681809592e.png?x-oss-process=style/water"
					alt="">
				<div class="inlinI">
					<router-link :to="{path:'/company/newcont',query:{newid:item.id}}" class="aclass">
						<h3>{{item.new_title}}</h3>
					</router-link>
					<div class="date">{{item.create_time}}</div>
				</div>
			</div>
			<div class="block pdb10 " style="float: right">
				<el-pagination @current-change="handleCurrentChange" @size-change="handSizeChange"
					:current-page.sync="page" :page-size="100" layout="prev, pager, next,total" :total='total'>
				</el-pagination>
			</div>
		</div>
		<div class="barprebox max1350 mt25" v-else-if="newlist.length==0">
			<i class="iconfont icon-icon-no-data"></i>
			<p  style="padding-top: 10px;">暂无数据</p>
		</div>
		<v-footer></v-footer>
	</div>
</template>

<script>
	import Cookies from 'js-cookie'
	// 公共头部组件
	import iHeader from "@/components/indexheader"
	// footer
	import vFooter from "@/components/Footer"
	import "@/assets/cont-01.css";
	import Vue from 'vue';
	import axios from 'axios';
	Vue.prototype.$axios = axios;
	export default {
		components: {
			iHeader,
			vFooter,
		},
		data() {
			return {
				msg: "company",
				showpage: false,
				total: 1,
				pcount: '12', //每页多少条
				page: 1, //当前页码数
				newlist: []
			}
		},
		created() {
			this.handnewslist()
		},
		methods: {
			handnewslist() {
				this.$postcn('partshome/newlist', {
					userid:Cookies.get('cuserid'),
					p: this.page, //第几页
					pcount: this.pcount, //一页显示多少条
				}, this).then((res) => {
					 if (res.data.code == -4004) {
						this.$refs.loginIndex.handLogin(window.location.href)
					}else {
						this.newlist = res.data.data
					}
				})
			},
			handleCurrentChange(val) {
				this.page = val;
				this.handnewslist();
			},
			handSizeChange(val) {
				this.pcount = val;
				this.handnewslist();
			},
		}
	}
</script>

<style scoped="scoped">
	.listD {
		text-align: left;
		padding: 10px 10px 10px 0;
		border-bottom: solid 1px #F2F2F2
	}

	.titleD {
		height: 120px;
		vertical-align: middle;
	}
    .icon-icon-no-data {
      	font-size: 66px;
      	margin-top: 50px;
      	display: inline-block;
      	margin-bottom: 30px;
      }
	.newimg {
		width: 150px;
		height: 90px;
		float: left;
		position: relative;
	}

	.inlinI {
		display: table-cell;
		vertical-align: middle;
		text-align: left;
		height: 90px;
		padding-left: 10px;
	}

	.inlinI .date {
		font-size: 14px;
		color: #999999;
		line-height: 25px;
	}

	.aclass {
		color: #222;
		text-decoration: none;
		cursor: pointer;
	}

	.aclass:hover {
		color: #005dbe;
	}
</style>



// WEBPACK FOOTER //
// src/pages/company/newslist.vue